import React from 'react'
import {useSelector} from 'react-redux'
import ProductListItemAtom from '../../../@atoms/to_content/product_list/productlist_item.atom'
import ProductListWrapperAtom from '../../../@atoms/to_content/product_list_wrapper/product_list_wrapper.atom'
import {Visit} from '../../../props_reusable/visit'
import {RootState} from '../../../store_redux'

const ProductListComponent: React.FC<Pick<Visit, 'products'>> = function ({
  products,
}) {
  const rootState = useSelector((state: RootState) => state)
  const {settings, labels} = rootState
  const {productQuantity} = labels.myOrders
  const ap_type = !settings.isProductImageVisible
    ? 'productImageNull'
    : 'productImage'
  return (
    <ProductListWrapperAtom>
      {products.map(p => (
        <ProductListItemAtom
          key={p.prodCode}
          ap_type={ap_type}
          ap_product_name={p.prodDesc}
          ap_product_quantity={`${productQuantity} ${p.quantity}`}
          ap_product_image={p.image}
          ap_product_services={p.services}
        />
      ))}
    </ProductListWrapperAtom>
  )
}

export default ProductListComponent
